import '../FormConfirmation/FormConfirmation.css'
import FormConfirmation from '../FormConfirmation/FormConfirmation'
import Footer from '../Footer/footer';

const Index = () => {
  return (
    <>
      <FormConfirmation />
      <Footer />
    </>
  )
}

export default Index